import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'ld-svg-icon',
  template: `
    <span [innerHTML]="safeSvg()" class="contents"></span>
  `,
  styles: `
    ld-svg-icon svg {
      width: 100%;
      height: 100%;
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'inline-flex items-center justify-center',
    role: 'img',
  },
})
export class SvgIconComponent {
  private readonly sanitizer = inject(DomSanitizer);

  src = input.required<string>();

  protected readonly safeSvg = computed(() => {
    const dataUri = this.src();
    if (!dataUri) {
      return '';
    }
    const svg = this.decodeSvgDataUri(dataUri);
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  });

  private decodeSvgDataUri(dataUri: string): string {
    const prefix = 'data:image/svg+xml,';
    if (!dataUri.startsWith(prefix)) {
      return '';
    }
    return decodeURIComponent(dataUri.slice(prefix.length));
  }
}
